import { useState } from 'react';
import { shipEditTruck, type PendingTruck } from './logistics-api';

// Правка идентификации отправленной (не выпущенной) машины — номер авто / водитель.
export function TruckEditModal({
  dealId,
  truck,
  onClose,
  onDone,
}: {
  dealId: number;
  truck: PendingTruck;
  onClose: () => void;
  onDone: () => void;
}) {
  // Метка вида «номер · водитель» — предзаполняем, разбив по разделителю.
  const [head, ...rest] = truck.label.split(' · ');
  const [plate, setPlate] = useState(head ?? '');
  const [driver, setDriver] = useState(rest.join(' · '));
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  async function save() {
    setBusy(true);
    setMsg(null);
    try {
      await shipEditTruck(dealId, truck.id, { plate: plate.trim(), driver: driver.trim() });
      onDone();
    } catch (e) {
      setMsg(e instanceof Error ? e.message : 'Не удалось сохранить.');
      setBusy(false);
    }
  }

  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-h">
          <div className="grow">
            <div className="m-cli">Править машину</div>
            <div className="m-no">идентификация · до выпуска на КПП</div>
          </div>
          <button className="icon-btn close-x" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mbody">
          {msg && <p className="err">{msg}</p>}
          <label className="fld">
            <span className="fld-l">Номер авто</span>
            <input
              value={plate}
              disabled={busy}
              autoFocus
              placeholder="напр. 123 ABC 02"
              onChange={(e) => setPlate(e.target.value)}
            />
          </label>
          <label className="fld">
            <span className="fld-l">Водитель / перевозчик</span>
            <input
              value={driver}
              disabled={busy}
              placeholder="напр. Иванов / ТК «Барыс»"
              onChange={(e) => setDriver(e.target.value)}
            />
          </label>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn ghost sm" disabled={busy} onClick={onClose}>
              Отмена
            </button>
            <button className="btn sm" disabled={busy} onClick={save}>
              {busy ? 'Сохраняем…' : 'Сохранить'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
